import i18n from '@/utils/i18n';
import { returnGoods } from '@/api/stock';

const moment = require('moment');

/**
 * 获取一个时间区间，今天0点到目前
 *
 * @returns {Date[]}
 */
export function getTodayRange() {
  const end = new Date(window.formateTimesStamp());
  const start = new Date(window.formateTimesStamp());
  start.setHours(0, 0, 0, 0);
  return [start, end];
}

/**
 * 获取一个时间区间，昨天0点 到 23:59:59
 *
 * @returns {Date[]}
 */
export function getYesterdayRange() {
  const end = new Date(window.formateTimesStamp());
  const start = new Date(window.formateTimesStamp());
  start.setTime(window.formateTimesStamp().setHours(0, 0, 0, 0) - 3600 * 1000 * 24);
  end.setTime(window.formateTimesStamp().setHours(0, 0, 0, 0) - 1000);
  return [start, end];
}

/**
 * 获取一个时间区间，最近一周
 *
 * @returns {Date[]}
 */
export function getLatestWeekRange() {
  const end = new Date(window.formateTimesStamp());
  const start = new Date(window.formateTimesStamp());
  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
  end.setSeconds(end.getSeconds() - 1);
  return [start, end];
}

/**
 * 获取一个时间区间，最近30天
 *
 * @returns {Date[]}
 */
export function getLatestThirtyDaysRange() {
  const end = new Date(window.formateTimesStamp());
  const start = new Date(window.formateTimesStamp());
  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
  end.setSeconds(end.getSeconds() - 1);
  return [start, end];
}

/**
 * 返回时间格式化
 *
 * @param datetime
 * @param format String
 */
export function datetimeFormat(datetime, format = 'YYYY-MM-DD HH:mm:ss') {
  return moment(datetime).format(format);
}

/**
 * 返回当月第一天
 * @returns {string}
 */
export function startOfMonth() {
  return moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
}

/**
 * 处理钟点房相关的预抵时间，0-6点之间，取T-1
 * @param {*} time
 * isTime   判断是否需要时分秒
 */
export function handlerMorningOrderDate(time, isHour, isTime) {
  const hourAndMin = datetimeFormat(time, 'HH:mm:ss');
  const isMorning = hourAndMin <= '06:00:00';
  if (isMorning && !isHour) {
    const newTime = new Date(time);
    const day = newTime.getDate();
    newTime.setDate(+day - 1);
    time = datetimeFormat(newTime);
  } else {
    const newTime = new Date(time);
    const day = newTime.getDate();
    newTime.setDate(day);
    time = datetimeFormat(newTime);
  }
  var dateFormat = isHour ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
  if (isTime) {
    dateFormat = isHour ? 'YYYY-MM-DD' : 'YYYY-MM-DD';
  }
  return datetimeFormat(time, dateFormat);
}
/**
 * 获取上周第一天和最后一天的日期 周一~周日
 */
export function getLastWeekData() {
  var lastweek = [];
  var date = new Date();
  // 上周一的日期
  lastweek[0] = date.setDate(date.getDate() - 7 - date.getDay() + 1);
  // 上周日的日期
  lastweek[1] = date.setDate(date.getDate() + 6);
  return lastweek;
}
/**
 * 获取上月第一天和最后一天的日期
 */
export function getLastMonthData() {
  var now = new Date();
  var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  var ed = new Date(now.getFullYear(), now.getMonth(), 0);
  return [fd, ed];
}

export function GetDateStr(AddDayCount) {
  var dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
  var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
  return y + '-' + m + '-' + d;
}

//type 1 当前时间减去接口时间  2 接口时间减去当前时间
export function computeSubtractByCurrentTime(dateTime, type) {
  // 获取当前日期对象
  const currentDate = new Date();

  // 获取当前的年份
  const year = currentDate.getFullYear();

  // 获取当前的月份（注意：月份是从0开始的，所以需要加1）
  const month = currentDate.getMonth() + 1;

  // 获取当前的日期
  const day = currentDate.getDate();

  // 格式化为字符串
  const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

  // 获取当前时间的毫秒时间戳
  const currentTimeInMillis = new Date(formattedDate);
  let timeDifferenceInMillis = 0;

  // 创建日期对象
  const dateObject = new Date(dateTime);
  // 获取日期对象的时间戳（毫秒）
  const interfaceTime = dateObject.getTime();

  if (type == 1) {
    // 计算两个时间戳之间的差值（毫秒）
    timeDifferenceInMillis = currentTimeInMillis - interfaceTime;
  } else if (type == 2) {
    // 计算两个时间戳之间的差值（毫秒）
    timeDifferenceInMillis = interfaceTime - currentTimeInMillis;
  }

  // 将毫秒差转换为天数
  const timeDifferenceInDays = Math.floor(timeDifferenceInMillis / (1000 * 60 * 60 * 24));
  return timeDifferenceInDays;
}
